import React, { useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "../services/apiMethods";
import useModifyVendorStatus from "../hooks/useModifyVendorStatus";
import DisplayStar from "../Componants/DisplayStar";
import SearchBarComp from "../Componants/SearchBarComp";
import { filterTheArray } from "../utils/HelperFunctions";

export default function YourFavourites() {
    const [searchValue, setSearchValue] = useState('');
  const Navigate = useNavigate();
  const { changeVendorLikeStatus } = useModifyVendorStatus();
  const {
    data: Favourites,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["FavouritesAll" ,searchValue],
    queryFn: () => getRequest(`/profile/favourites?search=${searchValue}`),
    enabled:searchValue !== null,
  });

  const handleLikeDislike = (id, status) => {
    changeVendorLikeStatus({ id: id, status });
  };

  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3 className="">Your Favourites</h3>
            <p>Here’s all of your favourite Electricians</p>
            <div className="enquiries-search stepper-content">
              <Form className="cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                <SearchBarComp setSearchValue={setSearchValue} />
                </Form.Group>
              </Form>
            </div>
            <Row className="mt-4 favourites-sec">
              {Array.isArray(Favourites?.data) &&
              Favourites?.data.length > 0 ? (
                <>
                  {Favourites?.data?.map((ele, index) => {
                    return (
                      <Col lg={4} key={index}>
                        <div className="businesses-cards business-Wrap">
                          <div className="next">
                            <div className="businesses-img">
                              {ele?.image ? (
                                <img
                                  src={ele?.image}
                                  className={
                                    ele?.subscription?.plan == "Premium"
                                      ? "prime"
                                      : ""
                                  }
                                />
                              ) : (
                                <div
                                  className={
                                    ele?.subscription?.plan == "Premium"
                                      ? "custom-circle prime"
                                      : "custom-circle "
                                  }
                                >
                                  <span className="inside-custom-circle">
                                    {ele?.bussinessName
                                      ? ele?.bussinessName.toUpperCase().at(0)
                                      : "N"}
                                  </span>
                                </div>
                              )}
                              {ele?.verificationStatus == "Approved" && (
                                <span>
                                 <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                          <rect width="25" height="25" rx="12.5" transform="matrix(-1 0 0 1 26 1)" fill="#337FE0" stroke="white" stroke-width="2" />
                                          <path d="M20.0001 10L11.7066 16.8581L8 13.2486" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                </span>
                              )}
                                  {ele?.subscription?.plan == "Premium" && (
                                    <span className="prime-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                        <rect width="25" height="25" rx="12.5" transform="matrix(-1 0 0 1 26 1)" fill="#FFC130" stroke="white" stroke-width="2" />
                                        <path d="M19.9998 12.42L18.7698 17.855C18.7454 17.9687 18.6821 18.0704 18.5908 18.1425C18.4996 18.2146 18.386 18.2526 18.2698 18.25H8.68976C8.57349 18.2526 8.45995 18.2146 8.36869 18.1425C8.27743 18.0704 8.21416 17.9687 8.18976 17.855L6.99976 12.42C6.97974 12.3282 6.986 12.2325 7.01784 12.1441C7.04968 12.0557 7.1058 11.978 7.17976 11.92C7.25393 11.8618 7.34305 11.8257 7.43683 11.816C7.5306 11.8063 7.62522 11.8233 7.70976 11.865L10.6298 13.28L13.0498 9C13.0934 8.92305 13.1566 8.85904 13.233 8.81451C13.3095 8.76998 13.3963 8.74652 13.4848 8.74652C13.5732 8.74652 13.6601 8.76998 13.7365 8.81451C13.8129 8.85904 13.8762 8.92305 13.9198 9L16.3398 13.285L19.2798 11.86C19.3649 11.8149 19.4613 11.7953 19.5573 11.8036C19.6533 11.812 19.7448 11.8479 19.8209 11.9071C19.897 11.9663 19.9543 12.0461 19.9861 12.1371C20.0178 12.2281 20.0225 12.3264 19.9998 12.42Z" fill="white" />
                                      </svg>
                                    </span>
                                  )}
                            </div>
                            <div>
                              <h3>{ele?.bussinessName}</h3>
                              <p className="mb-2">
                                {/* {ele?.city ? ele?.city : filterTheArray(ele?.address)} */}
                                     {ele?.city ||
                                                        `${filterTheArray(
                                                          ele?.address
                                                        )}, ${ele.postCode?.slice(0, 3)}`}
                              </p>
                              <span style={{ display: "flex" }}>
                                <DisplayStar
                                  rating={Math.floor(ele?.rating)}
                                  size={22}
                                />
                                {/* <span className="mt-2">
                                  ({ele?.review} reviews)
                                </span> */}

                                {ele?.review == 0 ?
                                          <span className="mt-2" >(0 reviews)</span> :
                                          <span className="mt-2" >({`${ele.review} ${ele.review == 1 ? 'review' : 'reviews'}`})</span>
                                        }
                              </span>
                            </div>
                          </div>
                          <button
                            className="theme-comm-btn w-100"
                            onClick={() =>
                              Navigate(
                                `/electrician-profile?vendorId=${ele?._id}`
                              )
                            }
                          >
                            View Profile
                          </button>
                          <div
                            onClick={() => handleLikeDislike(ele._id, false)}
                            className="favourites-like"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <rect width="24" height="24" fill="white" />
                              <path
                                d="M4.45067 13.9082L11.4033 20.4395C11.6428 20.6644 11.7625 20.7769 11.9037 20.8046C11.9673 20.8171 12.0327 20.8171 12.0963 20.8046C12.2375 20.7769 12.3572 20.6644 12.5967 20.4395L19.5493 13.9082C21.5055 12.0706 21.743 9.0466 20.0978 6.92607L19.7885 6.52734C17.8203 3.99058 13.8696 4.41601 12.4867 7.31365C12.2913 7.72296 11.7087 7.72296 11.5133 7.31365C10.1304 4.41601 6.17972 3.99058 4.21154 6.52735L3.90219 6.92607C2.25695 9.0466 2.4945 12.0706 4.45067 13.9082Z"
                                fill="#337FE0"
                                stroke="#337FE0"
                                strokeWidth="2"
                              />
                            </svg>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </>
              ) : (
                <p> No Data Found</p>
              )}
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
